import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnChooserService, FilterService, GridModule, PageService, ReorderService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgSelectModule } from '@ng-select/ng-select';
import { TimesheetverificationModule } from '../timesheetverification/timesheetverification.module';
import { enableRipple } from '@syncfusion/ej2-base';
import { ClaimsComponent } from './claims.component';
import { ClaimsRoutingModule } from './claims-routing.module';
import { ClaimsEditComponent } from './claims-edit/claims-edit.component';
import { ClaimsListComponent } from './claims-list/claims-list.component';
import { BatchesComponent } from './batches/batches.component';
import { QrBarCodeComponent } from './qr-barcode-invoice/qr-barcode-invoice.component';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
import { UacCoversheetComponent } from './uac-coversheet/uac-coversheet.component';
import { AppealRequestFormComponent } from './appeal-request-form/appeal-request-form.component';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
enableRipple(true);
@NgModule({
  declarations: [
    ClaimsComponent,
    ClaimsEditComponent,
    ClaimsListComponent,
    BatchesComponent,
    QrBarCodeComponent,
    UacCoversheetComponent,
    AppealRequestFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MyDatePickerModule,
    GridModule,
    NgSelectModule,
    PDFExportModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    DropDownListAllModule,
    ClaimsRoutingModule,
    TimesheetverificationModule,
    dropdownModule,
    
    NgbPopoverModule,
  ],
    providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService,ReorderService
  ],
 
})
export class ClaimsModule { }